/**
 * The JobTitleError name a refused job-title request carried, read off the
 * google.rpc.PreconditionFailure detail. Every part of that path is optional
 * on the wire, so an envelope missing any of it reads as no reason.
 *
 * The detail arrives under either spelling. svc-hr serializes with proto field
 * names, so an envelope the webapp proxy passed through carries
 * `precondition_failure`; the webapp's own error envelope is serialized with
 * JSON names, so a request the proxy itself refused carries
 * `preconditionFailure`.
 *
 * svc-hr will move the reason onto `error.details[].error_info.reason`, where
 * it carries an `HR_` domain prefix this helper is to strip; that read path is
 * not implemented yet, so the two live side by side when it lands.
 */
interface RawViolation {
  type?: string;
}

interface RawPreconditionFailure {
  violations?: RawViolation[];
}

interface RawErrorDetail {
  precondition_failure?: RawPreconditionFailure;
  preconditionFailure?: RawPreconditionFailure;
}

interface RawErrorEnvelope {
  error?: { details?: RawErrorDetail[] };
}

export function jobTitleErrorReason(envelope: unknown): string | undefined {
  const details = (envelope as RawErrorEnvelope | undefined)?.error?.details;

  return (Array.isArray(details) ? details : [])
    .flatMap(detail => {
      const violations = (
        detail?.precondition_failure ?? detail?.preconditionFailure
      )?.violations;

      return Array.isArray(violations) ? violations : [];
    })
    .map(violation => violation?.type)
    .find((type): type is string => typeof type === 'string');
}

export default jobTitleErrorReason;
